var render, staticRenderFns
import script from "./VMenuItem.vue?vue&type=script&lang=js&"
export * from "./VMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./VMenuItem.vue?vue&type=style&index=0&id=05989985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05989985",
  null
  
)

export default component.exports